import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import PageHeader from "../components/PageHeader";
import infoCircle from "../assets/info-circle.svg";
import MediaPickerModal from "../components/MediaPickerModal";
import { fetchSectionDetail, UpdateSection } from "../action/sectiondata";
import { useToast } from "../components/ToastProvider";
import { imageUrl } from "../utils/helper";


export default function ViewSection() {
  const { id } = useParams();
  const navigate = useNavigate();
 const { showToast } = useToast();
  const [sectionData, setSectionData] = useState(null); // full API response
  const [formData, setFormData] = useState({}); // dynamic editable values
  const [mediaPickerFor, setMediaPickerFor] = useState(null); // field key for image picker

  useEffect(() => {
    loadSection();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const loadSection = async () => {
    const res = await fetchSectionDetail(id);

    if (res?.status === 1) {
      setSectionData(res.data);
      setFormData(res.data.data || {}); // <-- contains title, description, cards
    }
  };

  // ---------------------
  // Update simple fields
  // ---------------------
  const updateField = (key, value) => {
    setFormData((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  // ---------------------
  // Update repeater fields (cards array)
  // ---------------------
  const updateRepeaterField = (index, key, value) => {
    setFormData((prev) => {
      const updatedCards = [...prev.cards];
      updatedCards[index][key] = value;
      return { ...prev, cards: updatedCards };
    });
  };

  if (!sectionData) return null;

  const fields = sectionData?.section_type_id?.fields || [];
 // Field definitions
  const values = formData; // actual values

  const handleUpdate = async () => {
    try {
      const payload = {
        type: sectionData.type,
        locale: sectionData.locale,
        is_template: true,
        section_type_id: sectionData.section_type_id._id,
        data: formData   // <-- THIS IS THE HEART OF EVERYTHING
      };

      const res = await UpdateSection(sectionData._id, payload);

      if (res.status === 1) {
        showToast("Section updated successfully", "success");
        navigate("/section", { state: { activeTab: "section" } });

      } else {
        showToast(res.message || "Failed to update", "error");
      }
    } catch (e) {
      showToast("Something went wrong", "error");
    }
  };

  return (
    <>
      {/* ====================== HEADER ====================== */}
      <PageHeader pageTitle="Section Detail">

          <button className="btn-white me-2" onClick={() => navigate("/section")}>
            Cancel
          </button>

          <button className="btn-black" onClick={handleUpdate}>
            Update
          </button>
      </PageHeader>

      {/* ====================== MAIN CONTENT ====================== */}
      <div className="page-container">
        <div className="row">

          {/* ====================== LEFT SIDE: DYNAMIC FIELDS ====================== */}
          <div className="col-md-8">
            <div className="theme-card p-3 mb-3">

              {Array.isArray(fields) &&
                fields.length > 0 &&
                fields.map((field, index) => {

                const key = field.key;
                const label = field.label;
                const type = field.type;
                const value = values[key];

                // --------------------------
                // ⭐ IMAGE FIELD DETECTION
                // --------------------------
                const isImage =
                  type === "image" ||
                  type === "file" ||
                  key === "image" ||
                  key === "logo" ||
                  (typeof value === "string" &&
                    (value.startsWith("media/") ||
                      value.startsWith("assets/") ||
                      value.endsWith(".png") ||
                      value.endsWith(".jpg") ||
                      value.endsWith(".jpeg") ||
                      value.endsWith(".webp") ||
                      value.endsWith(".svg")));

                if (isImage) {
                  return (
                    <div className="mb-3" key={index}>
                      <label className="frm-label">{label}</label>
                  <div className="profile_box">
                        <img
                          src={imageUrl(value)}
                          alt="Preview"
                          style={{
                            width: "120px",
                            height: "120px",
                            borderRadius: "8px",
                            objectFit: "contain",
                            background: "#f8fafc",
                            border: "1px solid #ccc",
                            padding: "4px",
                          }}
                        />

                        <button
                          className="btn-black mt-2"
                          onClick={() => setMediaPickerFor(key)}
                        >
                          Change Image
                        </button>
                  </div>
                    
                    </div>
                  );
                }

                // --------------------------
                // ⭐ TEXTAREA
                // --------------------------
                if (type === "textarea") {
                  return (
                    <div className="mb-3" key={index}>
                      <label className="frm-label">{label}</label>
                      <textarea
                        className="frm-input"
                        rows="4"
                        value={value || ""}
                        onChange={(e) => updateField(key, e.target.value)}
                      />
                    </div>
                  );
                }

                // --------------------------
                // ⭐ REPEATER
                // --------------------------
                if (type === "repeater") {
                  const childFields = field.fields || [];

                  return (
                    <div className="card-border p-3 mb-3" key={index}>
                      <div className="card-title mb-2">{label}</div>

                      {Array.isArray(value) &&
                        value.map((item, i) => (
                          <div className="card-border p-3 mb-3" key={i}>
                            {childFields.map((child, ci) => {
                              const childKey = child.key;
                              const childLabel = child.label;
                              const childValue = item[childKey];

                              const childIsImage =
                                child.type === "image" ||
                                child.type === "file" ||
                                childKey === "image" ||
                                childKey === "logo" ||
                                (typeof childValue === "string" &&
                                  (childValue.startsWith("media/") ||
                                    childValue.startsWith("assets/") ||
                                    childValue.endsWith(".png") ||
                                    childValue.endsWith(".jpg") ||
                                    childValue.endsWith(".jpeg") ||
                                    childValue.endsWith(".webp") ||
                                    childValue.endsWith(".svg")));

                              // Image inside repeater
                              if (childIsImage) {
                                return (
                                  <div className="mb-3" key={ci}>
                                    <label className="frm-label">{childLabel}</label>
                                    <div className="profile_box">
                                    <img
                                      src={imageUrl(childValue)}
                                      alt="Preview"
                                      style={{
                                        width: "120px",
                                        height: "120px",
                                        borderRadius: "8px",
                                        objectFit: "contain",
                                        background: "#f8fafc",
                                        border: "1px solid #e2e8f0",
                                        padding: "6px",
                                      }}
                                    />

                                    <button
                                      className="btn-black mt-2"
                                      onClick={() =>
                                        setMediaPickerFor(`cards.${i}.${childKey}`)
                                      }
                                    >
                                      Change Image
                                    </button>
                                    </div>
                                  </div>
                                );
                              }

                              return (
                                <div className="mb-3" key={ci}>
                                  <label className="frm-label">{childLabel}</label>
                                  <input
                                    type="text"
                                    className="frm-input"
                                    value={childValue || ""}
                                    onChange={(e) =>
                                      updateRepeaterField(i, childKey, e.target.value)
                                    }
                                  />
                                </div>
                              );
                            })}
                          </div>
                        ))}
                    </div>
                  );
                }

                // --------------------------
                // ⭐ NORMAL INPUT
                // --------------------------
                return (
                  <div className="mb-3" key={index}>
                    <label className="frm-label">{label}</label>
                    <input
                      type="text"
                      className="frm-input"
                      value={value || ""}
                      onChange={(e) => updateField(key, e.target.value)}
                    />
                  </div>
                );
              })}

            </div>
          </div>

          {/* ====================== RIGHT SIDE: SECTION NAME ====================== */}
          <div className="col-md-4">
            <div className="theme-card p-4 mb-3">
              <div className="card-title pb-3">Section Details</div>

              <div className="frm-group">
                <label className="frm-label d-flex align-items-center">
                  Section Name
                  <img className="ms-2" src={infoCircle} alt="Info" title="section name" />
                </label>

                <input
                  type="text"
                  className="frm-input"
                  value={formData.title || ""}
                  onChange={(e) => updateField("title", e.target.value)}
                />
              </div>
            </div>
          </div>

        </div>
      </div>

      {/* ====================== MEDIA PICKER MODAL ====================== */}
      <MediaPickerModal
        show={!!mediaPickerFor}
        onClose={() => setMediaPickerFor(null)}
        onSelect={(url) => {
          // nested repeater support
          if (mediaPickerFor.startsWith("cards")) {
            const parts = mediaPickerFor.split(".");
            const index = Number(parts[1]);
            const key = parts[2];
            updateRepeaterField(index, key, url.replace(process.env.REACT_APP_BUCKET_URL, ""));
          } else {
            updateField(mediaPickerFor, url.replace(process.env.REACT_APP_BUCKET_URL, ""));
          }

          setMediaPickerFor(null);
        }}
      />
    </>
  );
}
